import * as yup from "yup";
export const QuotationMatrixSchema = yup.object().shape({
  type: yup.string().required("Required"),
  factor: yup.string().required("Required"),
  basePrice0To100: yup.number().required("Required"),
  basePrice101To200: yup.number().required("Required"),
  basePrice201To400: yup.number().required("Required"),
  basePrice401To500: yup.number().required("Required"),
  basePrice501To1000: yup.number().required("Required"),
  basePrice1001To1500: yup.number().required("Required"),
  basePrice1501To2000: yup.number().required("Required"),
  basePrice2001To2500: yup.number().required("Required"),
  basePrice2501To3000: yup.number().required("Required"),
  basePrice3001To3500: yup.number().required("Required"),
  basePrice3501To4000: yup.number().required("Required"),
  basePrice4001To4500: yup.number().required("Required"),
  basePrice4501To5000: yup.number().required("Required"),
  basePrice5001To5500: yup.number().required("Required"),
  basePrice5501To6000: yup.number().required("Required"),
  basePrice6001To6500: yup.number().required("Required"),
  basePrice6501To7000: yup.number().required("Required"),
  basePrice7001To7500: yup.number().required("Required"),
  basePrice7501To8000: yup.number().required("Required"),
  basePriceGreater8000: yup.number().required("Required"),
  sqMtrWeed: yup.number().required("Required"),
  markupPercent0To100: yup.number().required("Required"),
  markupPercent101To200: yup.number().required("Required"),
  markupPercent201To400: yup.number().required("Required"),
  markupPercent401To500: yup.number().required("Required"),
  markupPercent501To1000: yup.number().required("Required"),
  markupPercent1001To1500: yup.number().required("Required"),
  markupPercent1501To2000: yup.number().required("Required"),
  markupPercent2001To2500: yup.number().required("Required"),
  markupPercent2501To3000: yup.number().required("Required"),
  markupPercent3001To3500: yup.number().required("Required"),
  markupPercent3501To4000: yup.number().required("Required"),
  markupPercent4001To4500: yup.number().required("Required"),
  markupPercent4501To5000: yup.number().required("Required"),
  markupPercent5001To5500: yup.number().required("Required"),
  markupPercent5501To6000: yup.number().required("Required"),
  markupPercent6001To6500: yup.number().required("Required"),
  markupPercent6501To7000: yup.number().required("Required"),
  markupPercent7001To7500: yup.number().required("Required"),
  markupPercent7501To8000: yup.number().required("Required"),
  markupPercentGreater8000: yup.number().required("Required"),
});
